import { locationSelectors } from "../../common/store/slice/locationSlice";
import { buildQuery } from "../FirestoreClient";
import { defaultSWRConfig } from "../swrConfig";
import { queryLatestEntityVersion } from "./common";
import { Country } from "@pslifestyle/common/src/models/countries";
import { StaticTranslations } from "@pslifestyle/common/src/schemas";
import { getDocs } from "firebase/firestore";
import { useSelector } from "react-redux";
import useSWR from "swr";

export const fetchPrivacyPolicyForCountry = async (country: Country) => {
  const collectionName = "staticTranslations";
  const policyVersion = await queryLatestEntityVersion(collectionName);

  const queryPath = `${collectionName}/${policyVersion}/${country.code}/`;
  const privacyPolicies = buildQuery(queryPath);
  const queryResults = await getDocs(await privacyPolicies);
  const staticTranslationsFromDb: StaticTranslations[] = queryResults.docs
    .filter(Boolean)
    .map((question) => question.data() as StaticTranslations);
  if (!staticTranslationsFromDb.length) {
    return [];
  }
  const privacyPolicy = staticTranslationsFromDb.find(
    (staticContent) => staticContent.privacyPolicy,
  );
  return [policyVersion, privacyPolicy];
};

export const usePrivacyPolicyForCurrentCountry = () => {
  const country = useSelector(locationSelectors.country);

  return useSWR(
    country ? ["fetchPrivacyPolicy", country] : null,
    ([_, selectedCountry]) => fetchPrivacyPolicyForCountry(selectedCountry),
    defaultSWRConfig,
  );
};
